import './gallery-popup.scss';
import 'slick-carousel';
import { Fancybox } from "@fancyapps/ui";

export default async () => {
    const $for = $( '.js-gallery-for' );
    let slideIndex = 0;

    $('.js-gallery-btn').click(function() {
        const getSlideIndex = $(this).data('slide-idx');
        if (typeof getSlideIndex !== 'undefined') {
            slideIndex = getSlideIndex + 1;
            $for.slick('slickGoTo', getSlideIndex + 1);
        }
    });

    $for.slick( {
        rows: 0,
        dots: false,
        arrows: false,
        infinite: true,
        swipeToSlide: true,
        initialSlide: slideIndex,
        slidesToShow: 1,
        slidesToScroll: 1,
        asNavFor: '.js-gallery-nav',
    } );

    $(document).on('keydown', function(e) {
        if(e.keyCode === 37) {
            $for.slick('slickPrev');
        }
        if(e.keyCode === 39) {
            $for.slick('slickNext');
        }
    });

    const downloadImage = $( '.js-download-image' );

    downloadImage.click( function () {
        const activeSlide = $( '.gallery-popup__for-item.slick-current img' );

        // Set the key (path) of the object you want to generate a download link for
        const objectKey = activeSlide.attr( 'src' );
        const recordId = objectKey.split('/').at(-2);
        const fileName = objectKey.split('/').at(-1);
        createDownloadUrl(recordId, fileName);
    } );

    Fancybox.bind('[data-fancybox="gallery"]', {
        Carousel: {
            infinite: false,
        },
        Images: {
            zoom: true,
        },
    });

    async function createDownloadUrl(recordId, fileName){ // create the url to make the api call for an image download
        const apiUrl = `/api/default/project-media-download?recordId=${recordId}&fileName=${encodeURIComponent(fileName)}`;
        downloadImage.attr( 'href', apiUrl);
        downloadImage.attr( 'download', fileName);
    }

    function sliderInit () {
        let $nav = $( '.js-gallery-nav' );

        $nav.each( function () {
            let $navParent = $( this ).closest( '.gallery-popup' );

            $( this ).slick( {
                rows: 0,
                dots: false,
                arrows: false,
                infinite: true,
                slidesToShow: 6,
                centerMode: false,
                slidesToScroll: 1,
                variableWidth: true,
                swipeToSlide: true,
                asNavFor: '.js-gallery-for',
                focusOnSelect: true,
                responsive: [ {
                    breakpoint: 568,
                    settings: {
                        slidesToShow: 3,
                    },
                } ],
            } );

            // when gallery-popup opens, it always shows image 1 first
            $navParent.find( '.slides-numbers .active' ).html( 1 );

            if ( $( this ).find( '.gallery-popup__nav-item' ).length > 1 ) {
                $navParent.find( '.slides-numbers' ).show();
            } else {
                $navParent.find( '.slides-numbers' ).hide();
            }

            $( this ).on( 'afterChange', function ( event, slick, currentSlide ) {
                $navParent.find( '.slides-numbers .active' ).html( currentSlide + 1 );
            } );

            let sliderItemsNum = $( this ).find( '.slick-slide' ).not( '.slick-cloned' ).length;

            $navParent.find( '.slides-numbers .total' ).html( sliderItemsNum );
        } );
    }

    sliderInit();
};
